import angular from 'angular';
import './_media-placeholder.scss';
import MediaPickerModalService from '../MediaPickerModalService/MediaPickerModalService';

export default angular.module('cms.media.placeholder', [MediaPickerModalService])
    .component('mediaPlaceholder', {
        bindings: {
            model: '='
        },
        template: require('./media-placeholder.html'),
        controller: function($scope, MediaPickerModalService) {
            this.openMediaPicker = () => {
                MediaPickerModalService.open(this.model).then(model => {
                    this.model = model;
                    $scope.$emit('content-changed');
                });
            }
        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaPlaceholder/MediaPlaceholder.js